module.exports = __webpack_public_path__ + "static/media/numbers_quantity-min.45644a3d.jpg";